import { useAuth } from "@roastery/auth";
import { useTranslation } from "@roastery/i18n";
import { Button } from "@roastery/ui";
import { createFileRoute } from "@tanstack/react-router";
import { FullScreenMessage } from "../components/full-screen-message";

/**
 * Where signing out lands (US-23.6) — a page that says so, rather than the login screen the operator
 * has just left, which read as if the sign-out had failed.
 */
export const Route = createFileRoute("/signed-out")({
  component: SignedOut,
});

function SignedOut() {
  const { t } = useTranslation();
  const auth = useAuth();

  return (
    <FullScreenMessage
      testId="admin-signed-out"
      title={t("auth.signedOut.title")}
      description={t("auth.signedOut.description")}
      action={
        <Button data-testid="admin-sign-in-again" onClick={() => void auth.signinRedirect()}>
          {t("auth.signedOut.signInAgain")}
        </Button>
      }
    />
  );
}
